import { createFileRoute, redirect } from "@tanstack/react-router";
import { IntegrationsPage } from "@/app/partner/pages/integrations";
import { canAccessRoute } from "@/lib/auth";

export const Route = createFileRoute("/flex/dashboard/integrations")({
	beforeLoad: async ({ context }) => {
		const { partner } = context;
		const access = canAccessRoute(partner, "integrations");

		if (!access.allowed) {
			throw redirect({ to: "/flex/dashboard" });
		}
	},
	component: IntegrationsPage,
});
